import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {UserProfileService} from "../core/services/user-profile/user-profile.service";
import {MsalBroadcastService, MsalRedirectComponent, MsalService} from "@azure/msal-angular";
import {filter} from "rxjs/operators";
import {AuthenticationResult, EventMessage, EventType} from '@azure/msal-browser';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {LoaderComponent} from "./components/loader/loader.component";
import {NgIf} from "@angular/common";
import {CompanyService} from "../core/services/company/company.service";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent, NgIf],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent extends MsalRedirectComponent implements OnInit {
  title = 'payment-gateway';
  authenticated: boolean = false;

  constructor(private msalBroadcastService: MsalBroadcastService,
              private msalService: MsalService,
              private userProfileService: UserProfileService,
              private companyService: CompanyService,
              private destroyRef$: DestroyRef) {
    super(inject(MsalService));
  }

  override ngOnInit(): void {
    this.checkAuth();
    this.onLoadCompanies();
    if (window.location.pathname === '/company/new') {
      this.authenticated = true;
    }
  }


  checkAuth() {
    this.msalBroadcastService.msalSubject$.pipe(
      filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
      takeUntilDestroyed(this.destroyRef$)
    ).subscribe((result: EventMessage) => {
      const payload = result.payload as AuthenticationResult;
      if (payload) {
        this.msalService.instance.setActiveAccount(payload.account);
        this.userProfileService.checkoutProfile(payload);
      }
    })
  }

  private onLoadCompanies() {
    this.companyService.companiesSubject.pipe(takeUntilDestroyed(this.destroyRef$)).subscribe({
      next: (response) => {
        this.authenticated = true;
        const pathName = window.location.pathname;
        if (pathName == '/' && response.length > 0) {
          console.log(response)
          window.location.href = '/';

        }
      },
      error: (error) => {
        console.error('Error fetching companies', error);
      }
      }
    );
  }
}
